<template lang="pug">
section
    BaseHeader(
        :titulo='$t("mensagens.territorio.titulo")'
        :exibeBotao='false'
        :voltarPara='true'
    )

    .view-container.margen-bottom-pages.body
        CadastroLote(@territoriosCarregados='onTerritoriosCarregados')
        CadastroManual(
            @adicionar='adicionarTerritorio'
            :territoriosJaAdicionados='todosTerritorios'
        )

        div
            TabelaCadastroTerritorio(
                :territorios='territoriosPaginados'
                :removendo='removendoTerritorios'
                @territoriosSelecionados='selecionarTerritorios'
                @editarTerritorio='abrirEdicao'
            )

            .pagination
                b {{ todosTerritorios.length }} territorio{{ todosTerritorios.length !== 1 ? 's' : '' }}

                el-pagination(
                    small
                    background
                    layout='prev, pager, next'
                    :page-size='paginacao.tamanho'
                    :current-page.sync='paginacao.pagina'
                    :total='todosTerritorios.length'
                    @current-change='atualizarPagina'
                )

    el-dialog(
        title='Editar territorio'
        :visible.sync='edicao.visivel'
        width='640px'
    )
        el-form(label-position='top' size='small')
            .grid-edicao
                el-form-item(label='Nombre del territorio' required)
                    el-input(v-model='edicao.form.nome')
                el-form-item(label='Código único de empresa')
                    el-input(v-model='edicao.form.codigoUnicoEmpresa')
                el-form-item(label='Cultivo' required)
                    el-input(v-model='edicao.form.cultivo')
                el-form-item(label='Productor' required)
                    el-input(v-model='edicao.form.produtor')
                el-form-item(label='CUIT' required)
                    el-input(v-model='edicao.form.cuit' placeholder='XX-XXXXXXXX-X')
                el-form-item(label='RENSPA')
                    el-input(v-model='edicao.form.renspa')
                el-form-item(label='Departamento' required)
                    el-input(v-model='edicao.form.departamento')
                el-form-item(label='Distrito' required)
                    el-input(v-model='edicao.form.distrito')
                el-form-item(label='ONCCA' required)
                    el-input(v-model='edicao.form.oncca')
        span(slot='footer')
            el-button(@click='edicao.visivel = false') Cancelar
            el-button(type='primary' @click='salvarEdicao') Guardar

    footer.footer-acoes
        .remover
            el-button(
                v-if='removendoTerritorios'
                @click='removendoTerritorios = false'
            ) Cancelar

            el-button(
                v-if='!removendoTerritorios'
                type='danger'
                icon='el-icon-delete'
                @click='removendoTerritorios = true'
            ) Eliminar

            el-button(
                v-else
                type='danger'
                icon='el-icon-delete'
                @click='removerTerritorios'
            ) Confirmar la extracción

        el-button(
            type='primary'
            icon='el-icon-s-promotion'
            :loading='loading'
            :disabled='territoriosValidos.length === 0'
            @click='cadastrarTerritorios'
        ) {{ $t('mensagens.territorio.territorioAr.salvar') }}
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import CadastroLote from './componentes/cadastro-lote/index.vue';
import CadastroManual from './componentes/cadastro-manual/index.vue';
import TabelaCadastroTerritorio from './componentes/tabela-territorios/index.vue';
import TerritorioServiceArgentina from '@/services/TerritorioServiceArgentina.js';
import territorioService from '@/services/TerritorioService';
import { mapGetters } from 'vuex';

export default {
    name: 'index',
    components: {
        BaseHeader,
        CadastroLote,
        CadastroManual,
        TabelaCadastroTerritorio
    },
    data() {
        return {
            territoriosSelecionados: [],
            removendoTerritorios: false,
            loading: false,
            paginacao: {
                pagina: 1,
                tamanho: 10
            },
            edicao: {
                visivel: false,
                territorio: null,
                form: {}
            }
        };
    },

    computed: {
        ...mapGetters(['territoriosLotePreviewAR', 'nomeArquivoLotePreviewAR']),

        todosTerritorios() {
            return this.territoriosLotePreviewAR;
        },

        territoriosValidos() {
            return this.todosTerritorios.filter(t => t.status !== 'ERRO' && t.status !== 'SOBREPOSTO');
        },

        territoriosPaginados() {
            const inicio = (this.paginacao.pagina - 1) * this.paginacao.tamanho;
            return this.todosTerritorios.slice(inicio, inicio + this.paginacao.tamanho);
        }
    },

    methods: {
        onTerritoriosCarregados(previewData) {
            const territorios = previewData.itens.map(item => this.listagemTerritorioFactory(item));
            this.$store.dispatch('setTerritoriosLotePreviewAR', territorios);
            this.paginacao.pagina = 1;
        },

        adicionarTerritorio(territorio) {
            this.$store.dispatch('setTerritoriosLotePreviewAR', [...this.todosTerritorios, territorio]);
        },

        selecionarTerritorios(selecionados) {
            this.territoriosSelecionados = selecionados;
        },

        removerTerritorios() {
            const selecionados = new Set(this.territoriosSelecionados);
            const restantes = this.todosTerritorios.filter(t => !selecionados.has(t));
            this.$store.dispatch('setTerritoriosLotePreviewAR', restantes);
            this.territoriosSelecionados = [];
            this.removendoTerritorios = false;
        },

        atualizarPagina(pagina) {
            this.paginacao.pagina = pagina;
        },

        abrirEdicao(territorio) {
            const preview = territorio._preview;
            this.edicao.territorio = territorio;
            this.edicao.form = {
                nome: preview.nome,
                codigoUnicoEmpresa: preview.codigoUnicoEmpresa,
                cultivo: preview.cultivo,
                produtor: preview.produtor,
                cuit: preview.cuit,
                renspa: preview.renspa,
                departamento: preview.departamento,
                distrito: preview.distrito,
                oncca: preview.oncca
            };
            this.edicao.visivel = true;
        },

        salvarEdicao() {
            const form = this.edicao.form;
            const obrigatorios = ['nome', 'cultivo', 'produtor', 'cuit', 'departamento', 'distrito', 'oncca'];

            if (obrigatorios.some(campo => !String(form[campo] ?? '').trim())) {
                this.$notify.warning({ message: 'Complete los campos obligatorios.' });
                return;
            }

            if (!/^\d{2}-\d{8}-\d$/.test(String(form.cuit).trim())) {
                this.$notify.warning({ message: 'CUIT inválido. El formato esperado es XX-XXXXXXXX-X.' });
                return;
            }

            const original = this.edicao.territorio;
            const preview = { ...original._preview };
            Object.keys(form).forEach(campo => {
                preview[campo] = String(form[campo] ?? '').trim();
            });

            const atualizado = {
                ...original,
                nome: preview.nome,
                renspa: preview.renspa,
                informacoesAgricolas: preview.cultivo ? [{ nome: preview.cultivo }] : [],
                representantes: preview.produtor ? [{ nomeRazaoSocial: preview.produtor }] : [],
                _preview: preview
            };

            const lista = this.todosTerritorios.map(t => (t === original ? atualizado : t));
            this.$store.dispatch('setTerritoriosLotePreviewAR', lista);

            this.edicao.visivel = false;
            this.edicao.territorio = null;
        },

        async cadastrarTerritorios() {
            this.loading = true;
            try {
                const itensLote = this.todosTerritorios
                    .filter(t => t._preview)
                    .map(t => t._preview);
                const manuais = this.todosTerritorios.filter(t => !t._preview);

                let totalConfirmados = 0;
                let totalErros = 0;

                if (itensLote.length > 0) {
                    const { data } = await TerritorioServiceArgentina.confirmarTerritorios({
                        itens: itensLote,
                        nomeArquivo: this.nomeArquivoLotePreviewAR
                    });
                    totalConfirmados += data.totalConfirmados;
                    totalErros += data.totalErros;
                }

                const manuaisComErro = [];
                for (const manual of manuais) {
                    try {
                        await territorioService.addArgentina(this.manualTerritorioFactory(manual));
                        totalConfirmados++;
                    } catch (erro) {
                        manuaisComErro.push(manual);
                        totalErros++;
                    }
                }

                if (manuaisComErro.length > 0) {
                    this.$store.dispatch('setTerritoriosLotePreviewAR', manuaisComErro);
                } else {
                    this.$store.dispatch('clearTerritoriosLotePreviewAR');
                }
                this.$store.dispatch('clearNomeArquivoLotePreviewAR');

                if (totalConfirmados > 0) {
                    this.$notify.success({
                        message: this.$t('mensagens.territorio.territoriosCadastradosSucesso', { n: totalConfirmados })
                    });
                }

                if (totalErros > 0) {
                    this.$notify.warning({
                        message: `${totalConfirmados} territórios salvos, ${totalErros} com erro.`
                    });
                }

                if (manuaisComErro.length === 0) {
                    this.$router.push({ name: 'TerritorioArgentina' });
                }

            } catch (erro) {
                this.$notify.error({
                    message: erro?.response?.data?.message || 'Error al confirmar los territorios.'
                });
            } finally {
                this.loading = false;
            }
        },

        manualTerritorioFactory(manual) {
            const territorio = { ...manual };
            delete territorio.totalAreaHa;
            delete territorio.origem;
            delete territorio.status;
            delete territorio._preview;
            return territorio;
        },

        listagemTerritorioFactory(item) {
            return {
                nome: item.nome,
                renspa: item.renspa,
                provincia: item.provincia,
                informacoesAgricolas: item.cultivo ? [{ nome: item.cultivo }] : [],
                totalAreaHa: this.formatAreaHa(item.areaHa),
                representantes: item.produtor ? [{ nomeRazaoSocial: item.produtor }] : [],
                origem: 'Lote',
                status: item.status,
                _preview: item
            };
        },

        formatAreaHa(value) {
            const number = parseFloat(parseFloat(value ?? 0).toFixed(3)) || 0;
            return number.toLocaleString('pt-BR', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
            }) + ' ha';
        }
    }
};
</script>

<style lang="scss" scoped>
.body {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.footer-acoes {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    margin-top: 8px;
}

.grid-edicao {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 16px;
}

.pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--white);
    padding: 14px 11px;
    border-bottom-left-radius: 11px;
    border-bottom-right-radius: 11px;

    b {
        color: var(--primary);
        font-size: 12px;
    }
}
</style>
